module.exports = __webpack_public_path__ + "media/All Dead.ca6fac8f.mp3";